import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomPageHeadingProps {
  title: string | any;
  description?: string | any;
  size?: "xsmall" | "small" | "medium" | "large";
  isHandleIcon?: boolean;
  iconType?: "info" | "pending";
  descriptionStyle?: string;
  renderHtml?: boolean;
}

const CustomPageHeading = ({
  title,
  description,
  size = "large",
  isHandleIcon = false,
  iconType,
  descriptionStyle,
  renderHtml = false,
}: CustomPageHeadingProps) => {
  const getIcon = () => {
    if (iconType === "info") return <Icons.Info />;
    if (iconType === "pending") return <Icons.Clock />;
    return <Icons.Pencil />;
  };

  return (
    <div
      className={classNames(
        styles.headingContainer,
        size === "xsmall" && styles[size],
        "flex items-center gap-3",
      )}
    >
      {isHandleIcon && (
        <span
          className={classNames(
            styles.iconContainer,
            iconType && styles[iconType],
          )}
        >
          {getIcon()}
        </span>
      )}
      <div
        className={classNames(
          "flex flex-col xs:gap-1 gap-0 min-w-0",
          size !== "xsmall" && styles[size],
        )}
      >
        {size === "xsmall" && <h5>{title}</h5>}
        {size === "small" && <h3>{title}</h3>}
        {size === "medium" && <h2>{title}</h2>}
        {size === "large" && <h1>{title}</h1>}
        {renderHtml ? (
          <div
            className={classNames(
              styles.description,
              descriptionStyle && descriptionStyle,
            )}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        ) : (
          <p
            className={classNames(
              styles.description,
              descriptionStyle && descriptionStyle,
            )}
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default CustomPageHeading;
